(function () {
  'use strict';

  if (window.ECLOOfferV6 && window.ECLOOfferV6.enabled) return;

  var params = new URLSearchParams(window.location.search);
  var ui = params.get('offer_ui') || (window.ECLOOfferTheme && window.ECLOOfferTheme.ui) || 'format';
  var variant = String(
    params.get('offer_variant') ||
    (window.ECLOOfferTheme && window.ECLOOfferTheme.palette) ||
    ''
  ).toLowerCase();
  if (['accordion', 'modal', 'format'].indexOf(ui) < 0) ui = 'format';

  var current = document.currentScript && document.currentScript.src;
  if (!current) return;

  function asset(name) {
    return current.replace(/regenere-offer-experiment\.js(?=\?|$)/, name);
  }

  function load(name, done) {
    var script = document.createElement('script');
    script.src = asset(name);
    script.async = false;
    if (done) script.onload = done;
    document.head.appendChild(script);
  }

  function loadStyle(name, id) {
    if (document.getElementById(id)) return;
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = asset(name);
    document.head.appendChild(link);
  }

  if (variant === 'f') {
    loadStyle('regenere-offer-f-11sep.css', 'regenere-offer-f-style-link');
    load('regenere-offer-f-11sep-v2.js');
    return;
  }

  if (variant === 'fb') {
    loadStyle('regenere-offer-f-11sep.css', 'regenere-offer-f-style-link');
    loadStyle('regenere-offer-fb-11sep.css', 'regenere-offer-fb-style-link');
    load('regenere-offer-fb-11sep.js');
    return;
  }

  if (variant === 'fc') {
    loadStyle('regenere-offer-f-11sep.css', 'regenere-offer-f-style-link');
    loadStyle('regenere-offer-fb-11sep.css', 'regenere-offer-fb-style-link');
    load('regenere-offer-fc-11sep.js');
    return;
  }

  if (variant === 'fd') {
    loadStyle('regenere-offer-f-11sep.css', 'regenere-offer-f-style-link');
    loadStyle('regenere-offer-fb-11sep.css', 'regenere-offer-fb-style-link');
    loadStyle('regenere-offer-fd-11sep.css', 'regenere-offer-fd-style-link');
    load('regenere-offer-fc-11sep.js');
    return;
  }

  var paletteFiles = {
    fd1: 'regenere-offer-fd1-11sep.css',
    fd2: 'regenere-offer-fd2-11sep.css',
    fdc: 'regenere-offer-fdc-11sep.css',
    fdf: 'regenere-offer-fdf-11sep.css',
    f3: 'regenere-offer-f3-11sep.css',
    f4: 'regenere-offer-f4-11sep.css'
  };

  if (paletteFiles[variant]) {
    loadStyle('regenere-offer-f-11sep.css', 'regenere-offer-f-style-link');
    loadStyle('regenere-offer-fb-11sep.css', 'regenere-offer-fb-style-link');
    loadStyle(paletteFiles[variant], 'regenere-offer-'+variant+'-style-link');
    load('regenere-offer-fd-palette-alias-11sep.js');
    return;
  }

  var target = ui === 'accordion' || ui === 'modal'
    ? 'regenere-offer-experiment-ab-10sep.js'
    : 'regenere-offer-experiment-d-10sep.js';

  load(target, function () {
    load('regenere-offer-polish-10sep.js', function () {
      if (variant === 'b') load('regenere-offer-summary-b-10sep.js');
      if (variant === 'c') load('regenere-offer-subscription-c-11sep.js', function () {
        load('regenere-offer-c-copyfix-11sep.js');
      });
    });
  });
})();
